import React, { useMemo } from 'react';

import { useEditor } from '../../hooks/useEditor';
import * as S from './TreeList.style';
import { TreeListItem } from './TreeListItem';

export function TreeList(): React.ReactElement {
  const {
    state: { document },
  } = useEditor();
  const path = useMemo(() => [], []);
  return (
    <S.List>
      <TreeListItem node={document} path={path} />
    </S.List>
  );
}
